import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthRoute } from '@/lib/firebase/authRoute';
import Layout from '@/components/layout/Layout';
import Login from './routes/Login';
import Signup from './routes/Signup';
import VerifyEmail from './routes/VerifyEmail';
import { AuthLoadingBackdrop } from '@/components/layout/AuthLoadingBackdrop';

// Lazy loaded components
const HomeDashboard = React.lazy(() => import('@/features/HomeDashboard/HomeDashboard'));
const DataToolsRoutes = React.lazy(() => import('./routes/DataToolsRoutes'));
const PaidToolsRoutes = React.lazy(() => import('./routes/PaidToolsRoutes'));
const AdminToolsRoutes = React.lazy(() => import('./routes/AdminToolsRoutes'));
const SettingsRoutes = React.lazy(() => import('./routes/SettingsRoutes'));

const AppRoutes = () => {
  return (
    <Suspense fallback={<AuthLoadingBackdrop />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Protected Routes */}
        <Route element={<AuthRoute />}>
          <Route element={<Layout pageTitle="Dashboard" />}>
            <Route path="/" element={<HomeDashboard />} />
          </Route>
          <Route element={<Layout pageTitle="Paid Tools" />}>
            <Route path="/paid-tools/*" element={<PaidToolsRoutes />} />
          </Route>
          <Route element={<Layout pageTitle="Data Tools" />}>
            <Route path="/data-tools/*" element={<DataToolsRoutes />} />
          </Route>
          <Route element={<Layout pageTitle="Settings" />}>
            <Route path="/settings/*" element={<SettingsRoutes />} />
          </Route>
        </Route>

        {/* Admin Protected Route */}
        <Route element={<AuthRoute appRoles={['staff', 'admin']} />}>
          <Route element={<Layout pageTitle="EPL Admin" />}>
            <Route path="/epl-admin/*" element={<AdminToolsRoutes />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
